export const homeModule = {
  address: "番地",
  currentAddress: "位置情報",
  position: "マップ",
  positioning: "ロケーティング",
  positionFail: "現在地が取得できません",
  addressList: "お届け先住所",
  reposition: "リトライ",
  recommendStore: "オススメ店舗",
  sort1: "総合順位",
  sort2: "評判がいい",
  sort3: "客単価昇順",
  sort4: "客単価降順",
  sort5: "最低消費額",
  filterDistance: "距離",
  filterSales: "販売量",
  filter: "フィルター",
  filterPrice: "客単価",
  devCondition: "配達条件",
  storeType: "ジャンル",
  manage: "管理",
  positionError:
    "申し訳ありません。場所の判定に失敗しました。地域検索または都道府県をご利用ください。",
  changeText: "変更",
  noAddressTitle: "お届け先からお店を探す",
  memberPrivilege: "サブスク",
  productCoupon: "商品券",
  appointment: "予約",
  lineUp: "来店整理券",
};
export const searchModule = {
  sort: "表示順位",
  addressPlace: "店舗名をご入力ください",
  historySearch: "検索履歴",
  noData: "データが見つかりません。",
};
